var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7755 5.60248C49.7755 5.60248 67.5378 15.7957 72.1862 31.989C76.3746 46.6163 73.0204 53.5973 73.0204 53.5973C75.1625 55.9402 76.8503 58.6637 77.9974 61.628C79.1496 63.5325 79.8266 65.6883 79.9709 67.9119C80.1151 70.1354 79.7224 72.3611 78.826 74.3996C78.826 74.3996 78.5403 68.434 69.6834 67.1978C61.5665 66.0506 58.6152 73.9837 43.1129 73.5994C34.5234 73.4351 26.1044 71.1641 18.5898 66.9843C11.0751 62.8045 4.69309 56.8429 0 49.6192C7.57404 53.7665 17.4966 60.2054 29.8533 59.2159C42.21 58.2264 44.79 54.4147 44.79 54.4147C30.9004 43.381 18.606 30.4628 8.25973 16.0309C17.9737 24.1906 42.0358 40.4298 41.4758 40.0168C32.6743 31.3834 24.6217 22.0129 17.4051 12.0069C17.4051 12.0069 53.5068 41.8036 56.4124 41.6143C57.6067 39.1449 63.7808 26.3618 49.7726 5.59961L49.7755 5.60248Z",
    fill: "url(#paint0_linear_148_88)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_88",
    x1: 41.2558,
    y1: 33.1362,
    x2: 39.7337,
    y2: 74.4337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD2221"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.6ddb3b5d9efb25392a1b3a94627c5779.svg";
export { ForwardRef as ReactComponent };